import {
  PRODUCT_ADD_REQUEST,
  PRODUCT_ADD_SUCCESS,
  PRODUCT_ADD_FAILURE,
  PRODUCT_EDIT_REQUEST,
  PRODUCT_EDIT_SUCCESS,
  PRODUCT_EDIT_FAILURE,
  PRODUCT_VIEW_REQUEST,
  PRODUCT_VIEW_SUCCESS,
  PRODUCT_VIEW_FAILURE,
  PRODUCT_VIEW_ALL_REQUEST,
  PRODUCT_VIEW_ALL_SUCCESS,
  PRODUCT_VIEW_ALL_FAILURE,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_FAILURE,
  PRODUCT_RESET_STATE,
  PRODUCT_SEARCH_REQUEST,
  PRODUCT_SEARCH_FAILURE,
  PRODUCT_SEARCH_SUCCESS,
  PRODUCT_VIEW_BY_BRAND_ID_REQUEST,
  PRODUCT_VIEW_BY_BRAND_ID_SUCCESS,
  PRODUCT_VIEW_BY_BRAND_ID_FAILURE,
} from "./ProductTypes";

// Add Product Actions
export const productAddRequest = (credentials) => ({
  type: PRODUCT_ADD_REQUEST,
  payload: credentials,
});

export const productAddSuccess = (product) => ({
  type: PRODUCT_ADD_SUCCESS,
  payload: product,
});

export const productAddFailure = (error) => ({
  type: PRODUCT_ADD_FAILURE,
  payload: error,
});

// Edit Product Actions
export const productEditRequest = (productId, updates) => ({
  type: PRODUCT_EDIT_REQUEST,
  payload: { productId, updates },
});

export const productEditSuccess = (product) => ({
  type: PRODUCT_EDIT_SUCCESS,
  payload: product,
});

export const productEditFailure = (error) => ({
  type: PRODUCT_EDIT_FAILURE,
  payload: error,
});

// View Single Product Actions
export const productViewRequest = (productId) => ({
  type: PRODUCT_VIEW_REQUEST,
  payload: productId,
});

export const productViewSuccess = (product) => ({
  type: PRODUCT_VIEW_SUCCESS,
  payload: product,
});
export const productViewFailure = (error) => ({
  type: PRODUCT_VIEW_FAILURE,
  payload: error,
});

// View All Products Actions
export const productViewAllRequest = (payload) => ({
  type: PRODUCT_VIEW_ALL_REQUEST,
  payload,
});

export const productViewAllSuccess = (products) => ({
  type: PRODUCT_VIEW_ALL_SUCCESS,
  payload: products,
});

export const productViewAllFailure = (error) => ({
  type: PRODUCT_VIEW_ALL_FAILURE,
  payload: error,
});

// View Products By Brand Id Actions
export const productViewByBrandIdRequest = (brandId) => ({
  type: PRODUCT_VIEW_BY_BRAND_ID_REQUEST,
  payload: brandId,
});

export const productViewByBrandIdSuccess = (products) => ({
  type: PRODUCT_VIEW_BY_BRAND_ID_SUCCESS,
  payload: products,
});

export const productViewByBrandIdFailure = (error) => ({
  type: PRODUCT_VIEW_BY_BRAND_ID_FAILURE,
  payload: error,
});

// View All Search Products Actions
export const productSearchViewAllRequest = () => ({
  type: PRODUCT_SEARCH_REQUEST,
});

export const productSearchViewAllSuccess = (products) => ({
  type: PRODUCT_SEARCH_SUCCESS,
  payload: products,
});

export const productSearchViewAllFailure = (error) => ({
  type: PRODUCT_SEARCH_FAILURE,
  payload: error,
});

// Delete Product Actions
export const productDeleteRequest = (productId) => ({
  type: PRODUCT_DELETE_REQUEST,
  payload: productId,
});

export const productDeleteSuccess = (productId) => ({
  type: PRODUCT_DELETE_SUCCESS,
  payload: productId,
});

export const productDeleteFailure = (error) => ({
  type: PRODUCT_DELETE_FAILURE,
  payload: error,
});

//Reset Product
export const productResetState = () => ({
  type: PRODUCT_RESET_STATE,
});
